import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

export const useBlogsDetailsCMSData = () => {
  const { t } = useTranslation('');

  const data = useMemo(
    () => ({
      data: {
        BlogDetailsPage: {
          eagleRiderLabel: t('blog_details_page:eagle_rider'),
          allPostsLabel: t('blog_details_page:all_posts'),
          shareTitle: t('blog_details_page:share_title'),
          linkCopiedText: t('blog_details_page:link_copied'),
          shareModalTitle: t('blog_details_page:share_modal_title'),
          patternBackground: {
            small_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            medium_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            large_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            alt: t('blog_details_page:pattern_background_alt'),
          },
        },
        ShareLinkComponent: {
          shareText: t('common_share:share'),
          shareJourney: t('common_share:share_journey'),
          blueRidgeAdventure: t('common_share:blue_ridge_adventure'),
          copyLink: t('common_share:copy_link'),
          whatsApp: t('common_share:whats_app'),
          facebook: t('common_share:facebook'),
          email: t('common_share:email'),
          linkCopiedText: t('common_share:link_copied'),
        },
      },
    }),
    [t],
  );

  return data;
};
